var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import PropTypes from "prop-types";
import Typography from "../Typography";
import classnames from "classnames";
import { IconWarningAlt, IconPlaceholder } from "../../icons";
var clName = function (suffix) {
    if (suffix === void 0) { suffix = ""; }
    var mainClassName = "mex-input";
    return "".concat(mainClassName).concat(suffix);
};
export var Input = function (_a, ref) {
    var _b;
    var name = _a.name, label = _a.label, rightLabel = _a.rightLabel, rightIcon = _a.rightIcon, preRightIcon = _a.preRightIcon, errorText = _a.errorText, helpText = _a.helpText, onChange = _a.onChange, type = _a.type, leftIcon = _a.leftIcon, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.trailingIcon, trailingIcon = _d === void 0 ? false : _d, otherProps = __rest(_a, ["name", "label", "rightLabel", "rightIcon", "preRightIcon", "errorText", "helpText", "onChange", "type", "leftIcon", "className", "trailingIcon"]);
    var _e = useState(otherProps.value), val = _e[0], setVal = _e[1];
    var _f = useState(false), isFocused = _f[0], setIsFocused = _f[1];
    var Component = type === "textarea" ? "textarea" : "input";
    var classNames = classnames((_b = {},
        _b[clName("__input")] = true,
        _b[clName("__input-textarea")] = type === "textarea",
        _b[clName("__input--error")] = errorText,
        _b[clName("__input--disabled")] = otherProps.disabled,
        _b[clName("__input--focus")] = isFocused,
        _b[className] = className,
        _b));
    var inputStyle = otherProps.style;
    if (otherProps && otherProps.style) {
        delete otherProps.style;
    }
    var onChangeInput = function (e) {
        var value = e.target.value;
        setVal(value);
        onChange && onChange(e);
    };
    var placeholderIconStyle = {
        color: errorText ? "#D42E1C" : val ? "#00B14F" : "#A3A3A3",
    };
    return (_jsx(React.Fragment, { children: _jsxs("div", __assign({ className: "mex-input__wrapper", style: inputStyle ? inputStyle : {} }, { children: [_jsxs("div", __assign({ className: "mex-input__label" }, { children: [label && _jsx(Typography, __assign({ variant: "body02Regular" }, { children: label })), rightLabel && _jsx(Typography, __assign({ variant: "body02Regular" }, { children: rightLabel }))] })), _jsxs("div", __assign({ className: classNames }, { children: [leftIcon && _jsx("span", __assign({ className: "mex-input__left-icon" }, { children: leftIcon })), _jsx(Component, __assign({}, otherProps, { name: name, type: type }, ref, { onFocus: function () { return setIsFocused(true); }, onBlur: function () { return setIsFocused(false); }, onChange: onChangeInput, className: "mex-typography--body01Regular" })), trailingIcon && !otherProps.disabled && (_jsx("span", __assign({ className: "mex-input__placeholder-icon" }, { children: typeof trailingIcon === "boolean" && trailingIcon === true ? (_jsx(IconPlaceholder, { style: placeholderIconStyle })) : (trailingIcon) }))), preRightIcon && (_jsx("span", __assign({ style: {
                                borderTopRightRadius: !rightIcon ? "16px" : "0",
                                borderBottomRightRadius: !rightIcon ? "16px" : "0",
                            }, className: "mex-input__pre-right-icon" }, { children: preRightIcon }))), rightIcon && _jsx("span", __assign({ className: "mex-input__right-icon" }, { children: rightIcon }))] })), _jsxs("div", __assign({ className: "mex-input__footer" }, { children: [errorText && (_jsxs(Typography, __assign({ variant: "metadataRegular", className: "mex-input__footer--error" }, { children: [_jsx(IconWarningAlt, {}), _jsx("span", { children: errorText })] }))), helpText && (_jsxs(Typography, __assign({ variant: "metadataRegular", className: "mex-input__footer--help" }, { children: [_jsx(IconWarningAlt, {}), _jsx("span", { children: helpText })] })))] }))] })) }));
};
Input.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    rightLabel: PropTypes.string || PropTypes.node,
    rightIcon: PropTypes.string || PropTypes.node,
    preRightIcon: PropTypes.string || PropTypes.node,
    trailingIcon: PropTypes.bool || PropTypes.node,
    errorText: PropTypes.string,
    helpText: PropTypes.string,
    type: PropTypes.string,
    className: PropTypes.string,
    leftIcon: PropTypes.string || PropTypes.node,
    onChange: PropTypes.func,
};
export default Input;
